/*
  Smooth open/close for <details data-smooth-accordion> (product accordion + Accordion section).
  - Works in every browser (animates height with the Web Animations API).
  - One delegated click listener, so it also works after the theme editor re-renders a section.
  - Optional exclusive groups: details with the same data-accordion-group close each other (animated).
  - Falls back to the browser's normal instant toggle when JS is off or the user prefers reduced motion.
*/
(function () {
  if (window.__smoothAccordionLoaded) return;
  window.__smoothAccordionLoaded = true;

  var DURATION = 380;
  var EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';
  var instances = new WeakMap();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function Item(el) {
    this.el = el;
    this.summary = el.querySelector(':scope > summary');
    this.panel = el.querySelector(':scope > :not(summary)');
    this.animation = null;
    this.closing = false;
    this.expanding = false;
  }

  Item.prototype.finish = function (open) {
    this.el.open = open;
    this.animation = null;
    this.closing = false;
    this.expanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
    if (this.panelAnimation) {
      this.panelAnimation.cancel();
      this.panelAnimation = null;
    }
  };

  Item.prototype.run = function (startH, endH, open) {
    var self = this;
    if (this.animation) this.animation.cancel();

    this.animation = this.el.animate(
      { height: [startH + 'px', endH + 'px'] },
      { duration: DURATION, easing: EASING }
    );
    this.animation.onfinish = function () { self.finish(open); };
    this.animation.oncancel = function () {
      self.closing = false;
      self.expanding = false;
    };

    // soft fade/slide of the content so it feels light rather than mechanical
    if (this.panel) {
      if (this.panelAnimation) this.panelAnimation.cancel();
      this.panelAnimation = this.panel.animate(
        open
          ? { opacity: [0, 1], transform: ['translateY(-6px)', 'translateY(0)'] }
          : { opacity: [1, 0], transform: ['translateY(0)', 'translateY(-6px)'] },
        { duration: DURATION * 0.8, easing: 'ease-out', fill: 'both' }
      );
    }
  };

  Item.prototype.shrink = function () {
    this.closing = true;
    this.expanding = false;
    this.el.style.overflow = 'hidden';
    var startH = this.el.offsetHeight;
    var endH = this.summary.offsetHeight;
    this.run(startH, endH, false);
  };

  Item.prototype.expand = function () {
    this.expanding = true;
    this.closing = false;
    this.el.style.overflow = 'hidden';
    var startH = this.el.offsetHeight;
    this.el.style.height = startH + 'px';
    this.el.open = true;

    var self = this;
    window.requestAnimationFrame(function () {
      var endH = self.summary.offsetHeight + (self.panel ? self.panel.offsetHeight : 0);
      self.run(startH, endH, true);
    });
  };

  function getItem(el) {
    var item = instances.get(el);
    if (!item) {
      item = new Item(el);
      instances.set(el, item);
    }
    return item;
  }

  function closeOthers(current, instant) {
    var group = current.getAttribute('data-accordion-group');
    if (!group) return;
    document.querySelectorAll('details[data-smooth-accordion][data-accordion-group="' + group + '"]').forEach(function (other) {
      if (other === current || !other.open) return;
      if (instant) other.open = false;
      else getItem(other).shrink();
    });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('details[data-smooth-accordion] > summary');
    if (!summary) return;
    if (prefersReducedMotion() || !summary.parentElement.animate) {
      // let the browser toggle normally, but keep exclusive groups working
      if (!summary.parentElement.open) closeOthers(summary.parentElement, true);
      return;
    }

    event.preventDefault();
    var item = getItem(summary.parentElement);

    if (item.closing || !item.el.open) {
      closeOthers(item.el);
      item.expand();
    } else if (item.expanding || item.el.open) {
      item.shrink();
    }
  });
})();
